import { RootStore } from '../rootStore';

import { ADMIN_CONSTANTS } from 'api/endpoints';
import { observable } from 'mobx';

interface AdminConstantsData {
  [key: string]: any;
}

export class AdminConstantsStore {
  rootStore: RootStore;
  @observable data: AdminConstantsData;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.data = {};
  }

  fetchData = async () => {
    const response = await this.rootStore.stores.apiStore.get<AdminConstantsData>(ADMIN_CONSTANTS);
    if (response?.data) {
      this.data = response.data;
    }
  };
}
